import { SecurityAssetSecurityType } from '@fintronners/react-api/src';
import {
  OrderDirection,
  SecurityAssetOrderField,
  SecurityFixedIncomeDetailsFixedIncomeType,
  SecurityFixedIncomeDetailsFixedIncomeSubtype,
  SecurityAssetEdgeColumn,
  MutualFundDetailsMutualFundsLoadType,
} from '@fintronners/react-api/src';

import type { SecurityCategory, SecurityAssetDefaultOrder, LoadTypeOptions } from './types';

export const SECURITY_CATEGORY = {
  STOCK: 'stock',
  ETF: 'etf',
  MUTUAL_FUND: 'mutual_fund',
  FIXED_INCOME: 'fixed_income',
} as const;

export const STOCK_SECURITY_TYPES = [
  SecurityAssetSecurityType.Cs,
  SecurityAssetSecurityType.Cvr,
  SecurityAssetSecurityType.Pfd,
];

export const ETF_SECURITY_TYPES = [SecurityAssetSecurityType.Etf, SecurityAssetSecurityType.Etn];
export const MUTUAL_FUND_SECURITY_TYPES = [SecurityAssetSecurityType.MutualFund];
export const FIXED_INCOME_SECURITY_TYPES = [SecurityAssetSecurityType.FixedIncome];

export const LOAD_TYPE_OPTIONS: LoadTypeOptions = {
  [MutualFundDetailsMutualFundsLoadType.MutualFundsLoadTypeFrontLoad]: 'Front-end load',
  [MutualFundDetailsMutualFundsLoadType.MutualFundsLoadTypeBackLoad]: 'Back-end load',
  [MutualFundDetailsMutualFundsLoadType.MutualFundsLoadTypeNoLoad]: 'No load',
};

export const DEFAULT_SECURITIES_SORTING: Record<SecurityCategory, SecurityAssetDefaultOrder> = {
  [SECURITY_CATEGORY.STOCK]: {
    direction: OrderDirection.Desc,
    field: SecurityAssetOrderField.MarketCap,
  },
  [SECURITY_CATEGORY.ETF]: {
    direction: OrderDirection.Desc,
    field: SecurityAssetOrderField.MarketCap,
  },
  [SECURITY_CATEGORY.MUTUAL_FUND]: {
    direction: OrderDirection.Desc,
    field: SecurityAssetOrderField.MarketCap,
  },
  [SECURITY_CATEGORY.FIXED_INCOME]: {
    direction: OrderDirection.Desc,
    field: SecurityAssetOrderField.MarketCap,
    byEdgeColumn: SecurityAssetEdgeColumn.FixedIncomeDetailsIssuePrice,
  },
} as const;

export const BOND_TYPE_OPTIONS = {
  [SecurityFixedIncomeDetailsFixedIncomeType.FixedIncomeTypeCorporate]: 'Corporate',
  [SecurityFixedIncomeDetailsFixedIncomeType.FixedIncomeTypeTreasury]: 'Treasury',
  [SecurityFixedIncomeDetailsFixedIncomeSubtype.FixedIncomeSubtypeBill]: 'Bills',
  [SecurityFixedIncomeDetailsFixedIncomeSubtype.FixedIncomeSubtypeNote]: 'Notes',
  [SecurityFixedIncomeDetailsFixedIncomeSubtype.FixedIncomeSubtypeBond]: 'Bonds',
} as const;

export const BOND_TYPE_TREASURY_OPTION_KEY =
  SecurityFixedIncomeDetailsFixedIncomeType.FixedIncomeTypeTreasury;

export const BOND_TYPE_TREASURY_RELATED_OPTIONS_KEYS = [
  SecurityFixedIncomeDetailsFixedIncomeSubtype.FixedIncomeSubtypeBill,
  SecurityFixedIncomeDetailsFixedIncomeSubtype.FixedIncomeSubtypeNote,
  SecurityFixedIncomeDetailsFixedIncomeSubtype.FixedIncomeSubtypeBond,
] as const;

export const MATURITY_OPTIONS_KEYS = {
  LESS_THAN_ONE_YEAR: 'LESS_THAN_ONE_YEAR',
  ONE_TO_THREE_YEARS: 'ONE_TO_THREE_YEARS',
  THREE_TO_FIVE_YEARS: 'THREE_TO_FIVE_YEARS',
  FIVE_TO_TEN_YEARS: 'FIVE_TO_TEN_YEARS',
  TEN_TO_TWENTY_YEARS: 'TEN_TO_TWENTY_YEARS',
  TWENTY_PLUS_YEARS: 'TWENTY_PLUS_YEARS',
} as const;

export const MATURITY_OPTIONS = {
  [MATURITY_OPTIONS_KEYS.LESS_THAN_ONE_YEAR]: '<= 1 Yr',
  [MATURITY_OPTIONS_KEYS.ONE_TO_THREE_YEARS]: '1-3 Yrs',
  [MATURITY_OPTIONS_KEYS.THREE_TO_FIVE_YEARS]: '3-5 Yrs',
  [MATURITY_OPTIONS_KEYS.FIVE_TO_TEN_YEARS]: '5-10 Yrs',
  [MATURITY_OPTIONS_KEYS.TEN_TO_TWENTY_YEARS]: '10-20 Yrs',
  [MATURITY_OPTIONS_KEYS.TWENTY_PLUS_YEARS]: '20+ Yrs',
} as const;

export const CALLABLE_OPTIONS = {
  YES: true,
  NO: false,
} as const;

export const FRACTIONAL_OPTIONS = {
  YES: true,
  NO: false,
} as const;
